var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _MarkdownRules = _interopRequireDefault(require("./MarkdownRules"));
var _styles = require("../../styles");
var _Header = require("../Header");
var _utils = require("../../utils");
var _excluded = ["children", "containerStyle", "textStyle", "nativeID", "textMarkColor"];
var Text = exports.Text = (0, _react.memo)(function (_ref) {
  var _children$toString$re;
  var children = _ref.children,
    containerStyle = _ref.containerStyle,
    textStyle = _ref.textStyle,
    nativeID = _ref.nativeID,
    textMarkColor = _ref.textMarkColor,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var text = (_children$toString$re = children == null ? void 0 : children.toString().replace(/<br\s*\/*>/gi, '\n')) != null ? _children$toString$re : '';
  var mdRules = Object.assign({}, _simpleMarkdown["default"].defaultRules, _MarkdownRules["default"]);
  var mdParse = _simpleMarkdown["default"].parserFor(mdRules);
  var clarityStyles = _styles.STYLES.useStyles();
  var headerContext = (0, _react.useContext)(_Header.HeaderContext);
  var navigationContext = (0, _utils.useNavigationContext)();
  var mdOutput = _simpleMarkdown["default"].outputFor(mdRules, 'react', {
    containerStyle: containerStyle,
    textStyle: textStyle,
    nativeID: nativeID,
    sharedStyles: Object.assign({}, clarityStyles, headerContext),
    navigationContext: navigationContext,
    extraProps: props,
    textMarkColor: textMarkColor
  });
  var mdSyntaxTree = mdParse(text);
  var mdResult = mdOutput(mdSyntaxTree);
  return mdResult;
});